import React from 'react'
import { Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Sidebar from 'react-sidebar'

import FaBars from 'react-icons/lib/fa/bars'

import AddAudience from '../add-audience/new'
import EditAudience from '../add-audience/edit'
import ImportAudience from '../import-audience'
import ImportAudienceBulk from '../import-audience-bulk'
import ImportAudienceOptOut from '../import-audience-optout'

import ImportLicenseBulkUpload from '../bulk-create/license'
import ImportAudienceBulkUpload from '../bulk-create/audience'

import Audiences from '../audiences'
import Imports from '../imports'
import Events from '../events'
import Syncs from '../syncs'
import SyncsAudience from '../syncs/syncsAudience'
import AddLicense from '../add-license/new'
import EditLicense from '../add-license/edit'
import License from '../license'
import Revenue from '../revenue'
import RevenueBuyers from '../revenue/buyers'
import NotFound from '../notFound'
import SignIn from '../signIn'
import Settings from '../settings'
import NewPartner from '../settings/newPartner'
import EditPartner from '../settings/editPartner'
import SettingsServerToServer from '../settingsservertoserver'
import Users from '../users'
import Roles from '../roles'
import EditRoles from '../roles/edit'
import ForgotPassword from '../forgotPassword'
import ChangePassword from '../changePassword'

import DocumentationHome from '../documentation/index.js'
import DocumentationIntegrations from '../documentation/integrations.js'
import DocumentationCapabilities from '../documentation/capabilities'
import DocumentationAPI from '../documentation/api'
import DocumentationAudience from '../documentation/audience'
import DocumentationFileUpload from '../documentation/file_upload'
import DocumentationLicense from '../documentation/license'
import DocumentationRevenue from '../documentation/revenue'
import DocumentationFaq from '../documentation/faq'
import DocumentationSLA from '../documentation/sla'
import DocumentationTrackingUploadStatus from '../documentation/tracking_upload'
import DocumentationLimits from '../documentation/limits'

import Header from '../../components/Header'
import Drawer from '../../components/Drawer'
import AuthRoute from '../../components/AuthRoute'

import './app.css'

const styles = {
    contentHeaderMenuLink: {
        textDecoration: 'none',
        color: 'black',
        padding: 8
    },
    content: {
        padding: '16px'
    }
}

const mql = window.matchMedia(`(min-width: 1000px)`)

const pathToHideDrawer = [
    '/licenses/new',
    '/licenses/edit',
    '/roles/new',
    '/roles/edit',
    '/audiences/new',
    '/audiences/import',
    '/audiences/import-bulk',
    '/audiences/import-optout',
    '/audiences/bulk-create',
    '/licenses/bulk-create',
    '/signin',
    '/doc',
    '/forgot-password',
    '/change-password',
    '/properties/.+'
]

class App extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            mql: mql,
            docked: false,
            open: false
        }
    }

    componentDidMount() {
        mql.addListener(this.mediaQueryChanged)
        this.setState({ mql: mql, docked: mql.matches })
        console.group('App componentDidMount')
        console.log(this.props)
        console.groupEnd()
    }

    componentWillUnmount() {
        this.state.mql.removeListener(this.mediaQueryChanged)
    }

    onSetOpen = open => {
        this.setState({ open: open })
    }

    mediaQueryChanged = () => {
        this.setState({
            mql: mql,
            docked: this.state.mql.matches
        })
    }

    toggleOpen = ev => {
        this.setState({ open: !this.state.open })

        if (ev) {
            ev.preventDefault()
        }
    }

    render() {
        //if (!this.props.signedInCompleted) return <div />
        const sidebar = <Drawer />

        const contentHeader = (
            <span style={{ display: 'flex' }}>
                {!this.state.docked && !this.state.open && (
                    <a onClick={this.toggleOpen.bind(this)} style={styles.contentHeaderMenuLink}>
                        <FaBars />
                    </a>
                )}
            </span>
        )
        const location = this.props.location.pathname

        console.log(pathToHideDrawer.indexOf(u => location.match(u)))

        const sidebarProps = {
            sidebar: sidebar,
            docked: this.state.docked && pathToHideDrawer.findIndex(path => location.match(path) !== null) === -1,
            open: this.state.open,
            onSetOpen: this.onSetOpen
        }

        return (
            <div className="dashboard-wrapper">
                <div className="dashboard container-fluid">
                    <Sidebar {...sidebarProps}>
                        <Header title={contentHeader}>
                            <Switch>
                                <AuthRoute exact userRequired isActiveRequired path="/audiences/new" component={AddAudience} />
                                <AuthRoute exact userRequired isActiveRequired path="/audiences/edit/:id" component={EditAudience} />
                                <AuthRoute exact userRequired isActiveRequired path="/audiences/import" component={ImportAudience} />
                                <AuthRoute exact userRequired isActiveRequired path="/audiences/import-bulk" component={ImportAudienceBulk} />
                                <AuthRoute exact userRequired isActiveRequired path="/audiences/import-optout" component={ImportAudienceOptOut} />
                                <AuthRoute exact userRequired isActiveRequired path="/audiences/bulk-create" component={ImportAudienceBulkUpload} />
                                <AuthRoute exact userRequired isActiveRequired path="/licenses/bulk-create" component={ImportLicenseBulkUpload} />
                                <AuthRoute exact userRequired isActiveRequired path="/audiences" component={Audiences} />
                                <AuthRoute exact userRequired isActiveRequired path="/imports" component={Imports} />
                                <AuthRoute exact userRequired isActiveRequired path="/syncs" component={Syncs} />
                                <AuthRoute exact userRequired isActiveRequired path="/syncs/audiences" component={SyncsAudience} />
                                <AuthRoute exact userRequired isActiveRequired path="/licenses/new" component={AddLicense} />
                                <AuthRoute exact userRequired isActiveRequired path="/licenses/edit/:id" component={EditLicense} />
                                <AuthRoute exact userRequired isActiveRequired path="/licenses" component={License} />
                                <AuthRoute exact userRequired isActiveRequired path="/revenue" component={Revenue} />
                                <AuthRoute exact userRequired isActiveRequired path="/revenue/buyers" component={RevenueBuyers} />
                                <AuthRoute exact userRequired isActiveRequired path="/events" component={Events} />

                                {/* hide home and redirect to audiences page as home  */}
                                <AuthRoute exact userRequired path="/" component={Audiences} />

                                <AuthRoute userRequired path="/settings/partner/new" component={NewPartner} />
                                <AuthRoute userRequired path="/settings/partner/edit/:id" component={EditPartner} />
                                <AuthRoute userRequired path="/settings" component={Settings} />

                                <AuthRoute userRequired path="/servertoserver" component={SettingsServerToServer} />
                                <AuthRoute userRequired path="/users" component={Users} />
                                <AuthRoute userRequired path="/roles/new" component={EditRoles} />
                                <AuthRoute userRequired path="/roles/edit/:id" component={EditRoles} />
                                <AuthRoute userRequired path="/roles" component={Roles} />
                                <AuthRoute path="/signin" component={SignIn} />

                                {/* documentation public pages */}
                                <AuthRoute path="/doc/home" component={DocumentationHome} />
                                <AuthRoute path="/doc/integrations" component={DocumentationIntegrations} />
                                <AuthRoute path="/doc/capabilities" component={DocumentationCapabilities} />
                                <AuthRoute path="/doc/api" component={DocumentationAPI} />
                                <AuthRoute path="/doc/audience" component={DocumentationAudience} />
                                <AuthRoute path="/doc/file_upload" component={DocumentationFileUpload} />
                                <AuthRoute path="/doc/license" component={DocumentationLicense} />
                                <AuthRoute path="/doc/revenue" component={DocumentationRevenue} />
                                <AuthRoute path="/doc/faq" component={DocumentationFaq} />
                                <AuthRoute path="/doc/sla" component={DocumentationSLA} />
                                <AuthRoute path="/doc/tracking_upload_status" component={DocumentationTrackingUploadStatus} />
                                <AuthRoute path="/doc/limits" component={DocumentationLimits} />

                                <AuthRoute path="/forgot-password" component={ForgotPassword} />
                                <AuthRoute path="/change-password" component={ChangePassword} />
                                <AuthRoute component={NotFound} />
                            </Switch>
                        </Header>
                    </Sidebar>
                </div>
            </div>
        )
    }
}

const mapStatetoProps = state => ({})

const mapDispatchToProps = {}

export default withRouter(
    connect(
        mapStatetoProps,
        mapDispatchToProps
    )(App)
)
